import * as React from 'react'
import { useIntl } from 'react-intl'
import dayjs from "dayjs";
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { TableHead } from '@mui/material'
import { SalesAnalysisState } from '../../../../features/types'
import { capitalize } from '../../../../utils/functions'

interface Props {
    analyzes: SalesAnalysisState[]
    isFetching: boolean
}

const SalesReportTable: React.FC<Props> = ({
    analyzes = [],
    isFetching,
}) => {
    const { formatMessage, locale } = useIntl()

    return (
        <Box>
            <TableContainer
                component={Paper}
                sx={{ border: 1, borderColor: 'grey.100', borderRadius: 2 }}
                elevation={0}
            >
                <Table
                    sx={{ minWidth: 500 }}
                    aria-label="custom pagination table"
                >
                    <TableHead sx={{ bgcolor: 'grey.100' }}>
                        <TableRow>
                            <TableCell>#</TableCell>

                            <TableCell align="right">
                                invoiceId
                            </TableCell>

                            <TableCell align="center">
                                txnId
                            </TableCell>

                            <TableCell align="center">
                                txnDate
                            </TableCell>

                            <TableCell>
                                {formatMessage({ id: 'registeredTime' })}
                            </TableCell>

                            <TableCell>
                                {formatMessage({ id: 'phone' })}
                            </TableCell>

                            <TableCell>
                                {formatMessage({ id: 'fullName' })}
                            </TableCell>

                            <TableCell>Курсы</TableCell>

                            <TableCell align="right">
                                {formatMessage({
                                    id: 'registeredSubject',
                                })}
                            </TableCell>

                            <TableCell align="right">
                                {formatMessage({
                                    id: 'topicNumber',
                                })}
                            </TableCell>

                            <TableCell align="right">
                                {formatMessage({
                                    id: 'totalSum',
                                })}
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    {analyzes.length ? (
                        <TableBody>
                            {analyzes.map((row, index) => (
                                <TableRow key={row.invoiceId}>
                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        {index + 1}
                                    </TableCell>

                                    <TableCell align="right">
                                        {row.invoiceId}
                                    </TableCell>

                                    <TableCell align="right">
                                        {row?.txnId}
                                    </TableCell>

                                    <TableCell align="right">
                                        {row?.txtDate && dayjs(row?.txtDate).format("DD.MM.YYYY HH:mm")}
                                    </TableCell>

                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        {row?.dateTime && dayjs(row?.dateTime).format("DD.MM.YYYY HH:mm")}
                                    </TableCell>

                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        {row.mobile}
                                    </TableCell>

                                    <TableCell>{row.fullName}</TableCell>

                                    <TableCell>
                                        {row[`title${capitalize(locale)}`]}
                                    </TableCell>

                                    <TableCell align="right">
                                        {row.subjectCount}
                                    </TableCell>

                                    <TableCell align="right">
                                        {row.topicCount}
                                    </TableCell>

                                    <TableCell align="right">
                                        {row?.amount?.toLocaleString()} т
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    ) : (
                        !isFetching && (
                            <TableBody>
                                <TableRow>
                                    <TableCell
                                        component="th"
                                        scope="row"
                                        align="center"
                                        colSpan={11}
                                    >
                                        {formatMessage({ id: 'noData' })}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )
                    )}

                </Table>
            </TableContainer>
        </Box>
    )
}

export default SalesReportTable
